export enum DashboardIDs {
  Activities = 'a453d5d9-9976-4cf5-b1ca-d00e8a4a2b70',
  ServiceRequests = '450f6be0-51c4-4cb7-b55c-3fe0fba504b9',
  Devices = '570c6400-325b-4299-ba08-f1f1295d6ab9',
  Facilities = '9018d716-45e8-40a9-a664-23387b20e955',
  Financials = 'e9ad004f-804e-46da-9e31-3ecdb6ce1aac',
  WarrantyAndContracts = '93e21551-32fd-4b08-9226-d7b1884cc185',
  Users = 'e236c799-b32e-4ccc-bfb1-0d972e764a3e',
  Logs = 'f13a8f1f-3967-4d6a-ae28-b434cc12edaa',
}
